import { dynamic } from '../../../helpers';

import videoCanPlay from './video/canPlay';
import audioCanPlay from './audio/canPlay';

import { IPlayerWrapper, PlayerType } from './types';

const players: IPlayerWrapper[] = [
  {
    type: PlayerType.AUDIO,
    canPlay: audioCanPlay,
    component: dynamic(() => import('./audio/AudioPlayer')),
  },
  {
    type: PlayerType.VIDEO,
    canPlay: videoCanPlay,
    component: dynamic(() => import('./video/VideoPlayer')),
  },
];

function canPlay(type: string) {
  return players.some((player) => player.canPlay(type));
}

function getPlayer(type: string): IPlayerWrapper {
  return players.find((player) => player.canPlay(type));
}

function getPlayerType(type: string) {
  const player = getPlayer(type);

  return player ? player.type : PlayerType.UNSUPPORTED;
}

export { canPlay, getPlayer, getPlayerType };
